import React, { Fragment } from 'react';
import { onEnterAction } from '../utils/a11y';

export type ProfileLink = {
  link?: string,
  trackingTag: string,
  label: string,
  classes?: string,
  hasHR?: boolean,
  isFeedback?: boolean,
  isLogOut?: boolean,
};

export interface Props {
  profileLinksArray: ProfileLink[];
  handleFeedbackClick(): void;
  handleLogoutClick(): void;
  trackingCallback(event: string, params?: Record<string, unknown>): Promise<void>;
}

export const ProfileLinks = ({ profileLinksArray, handleFeedbackClick, handleLogoutClick, trackingCallback }: Props): JSX.Element => {
  const linkClasses = 'cursor-pointer px-3 py-1 hover:bg-neutral-100 active:bg-sapphire active:text-white';

  const handleLinkClicked = async (profileLink: ProfileLink ): Promise<void> => {
    const trackingProps = {
      elementId: profileLink.trackingTag,
    };

    await trackingCallback('clicked-button', trackingProps);

    if (profileLink.isLogOut) {
      handleLogoutClick();
    } else {
      if (profileLink.isFeedback) {
        handleFeedbackClick();
      }

      if (profileLink.link) {
        window.location.href = profileLink.link;
      }
    }
  };

  return (
    <div className='justify-center'>
      {profileLinksArray.map((profileLink) => (
      <Fragment key={profileLink.label}>
        <div className={`${linkClasses} ${profileLink.classes ?? ''}`}
          role='menuitem'
          tabIndex={0}
          onClick={(e): void => {
            e.preventDefault();
            handleLinkClicked(profileLink);
          }}
          onKeyDown={(e): void => onEnterAction(e, () => handleLinkClicked(profileLink))}
        >
          {profileLink.label}
        </div>
        {profileLink.hasHR && (
          <hr className='my-2' />
        )}
      </Fragment>))}
    </div>
  );
};
